/* ============================================================
   Deal Management — standalone module shell.
   Mounted at /deal-management/* (see AnimatedRoutes) for direct
   URLs / deep-links. The primary entry point is now the inline tab
   inside the investor dashboard (see EmbeddedDealManagement.jsx).
   Light theme only — dark mode has been removed.
   ============================================================ */
'use strict';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import './dealManagement.css';
import { ToastProvider } from './components/Toast';
import { DealStateProvider } from './state';
import AppBar from './components/AppBar';
import DealRoutes from './DealRoutes';

export default function DealManagement() {
	const { pathname } = useLocation();

	// Scroll to top on screen change, matching the prototype's per-render behaviour
	useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

	return (
		<div className="dlg-dm dlg-dm--standalone">
			<ToastProvider>
				<DealStateProvider>
					<AppBar />
					<DealRoutes />
				</DealStateProvider>
			</ToastProvider>
		</div>
	);
}
